module.exports = __webpack_public_path__ + "img/x7.7cf07a87.png";